export default {
  lang_name: 'Portugues',
  tab_main: 'Principal', tab_upgrade: 'Melhoria', tab_prestige: 'Prestigio', tab_achievement: 'Conquistas', tab_mission: 'Missão', tab_domination: 'Mundo', tab_settings: 'Config.',
  hud_cps: '/s', hud_boost: 'Boost',
  main_tap_area: 'TOQUE!', main_combo: 'Combo',
  prod_informant: 'Informante', prod_informant_desc: 'Coleta de intel nas ruas',
  prod_hacker: 'Hacker', prod_hacker_desc: 'Infiltracao de redes humanas',
  prod_disguiser: 'Disfarce', prod_disguiser_desc: 'Camuflagem humana',
  prod_mindController: 'Controle Mental', prod_mindController_desc: 'Manipulacao de opiniao',
  prod_secretLab: 'Lab. Secreto', prod_secretLab_desc: 'Pesquisa reptiliana',
  prod_mediaCell: 'Celula de Midia', prod_mediaCell_desc: 'Controle de noticias',
  prod_shadowGovt: 'Gov. Sombra', prod_shadowGovt_desc: 'Substituicao de politicos',
  prod_deepBase: 'Base Profunda', prod_deepBase_desc: 'Mega-base subterranea',
  prod_orbitalStation: 'Estacao Orbital', prod_orbitalStation_desc: 'Rede de vigilancia satelital',
  prod_dimensionGate: 'Portal Dimensional', prod_dimensionGate_desc: 'Invocar forcas do lar',
  prod_planetController: 'Controle Planetario', prod_planetController_desc: 'Controle direto da Terra',
  prod_galacticBeacon: 'Farol Galactico', prod_galacticBeacon_desc: 'Linha direta com o QG',
  prod_locked: 'Desbloquear: ', prod_locked_prestige: 'Prestigio {n}x', prod_locked_time: '{n}min jogo',
  milestone_squad: 'Esquadrao', milestone_company: 'Companhia', milestone_battalion: 'Batalhao',
  milestone_regiment: 'Regimento', milestone_division: 'Divisao', milestone_corps: 'Corpo',
  click_basic_training: 'Treino Basico', click_combat_training: 'Treino de Combate',
  click_psychic_awaken: 'Despertar Psiquico', click_transform: 'Melhoria de Forma',
  click_telepathy: 'Telepatia', click_critical_eye: 'Olho Crítico',
  click_dimension_sense: 'Sentido Dimensional', click_galaxy_field: 'Campo Galactico',
  click_lethal_strike: 'Golpe Letal', click_absolute: 'Infiltracao Absoluta',
  click_planet_destroyer: 'Destruidor Planetario', click_galaxy_finger: 'Dedo do Overlord',
  special_info_network: 'Rede de Info', special_info_network_desc: 'Informante & Hacker x2',
  special_perfect_disguise: 'Disfarce Perfeito', special_perfect_disguise_desc: 'Todos agentes x1.5',
  special_mass_brainwash: 'Lavagem Cerebral em Massa', special_mass_brainwash_desc: 'Controle Mental & Midia x3',
  special_shadow_network: 'Rede Sombria', special_shadow_network_desc: 'Renda offline +25%',
  special_underground_empire: 'Imperio Subterraneo', special_underground_empire_desc: 'Todos agentes x2',
  special_orbital_surveillance: 'Vigilancia Orbital', special_orbital_surveillance_desc: 'Eventos dourados +50%',
  special_dimension_supply: 'Suprimento Dimensional', special_dimension_supply_desc: 'Renda de toque x5',
  special_galactic_alliance: 'Alianca Galactica', special_galactic_alliance_desc: '\uD83D\uDEF8 por segundo x10',
  special_combo_master: 'Mestre do Combo', special_combo_master_desc: 'Limite de combo x3',
  special_time_warp: 'Salto Temporal', special_time_warp_desc: 'Limite offline 12h',
  special_agent_synergy: 'Sinergia de Agentes', special_agent_synergy_desc: '\uD83D\uDEF8 por segundo x1.5',
  special_massive_infiltration: 'Infiltracao Massiva', special_massive_infiltration_desc: '\uD83D\uDEF8 por segundo x2',
  subtab_click: 'Clique', subtab_special: 'Especial',
  prestige_title: 'Reestruturacao', prestige_total_ip: '🛸 total ganho', prestige_gc_gain: '💎 a ganhar',
  prestige_gc_current: '💎 atual', prestige_execute: 'Reestruturar',
  prestige_confirm: 'Resetar todo progresso por {gc} Creditos Galacticos?',
  prestige_ad_bonus: 'Ver anuncio +50% 💎', prestige_requirement: 'Precisa de 10B+ 🛸',
  prestige2_title: 'Reestruturacao Galactica', prestige2_cores_gain: '🔮 a ganhar',
  prestige2_cores_current: '🔮 atuais', prestige2_execute: 'Reestruturacao Galactica',
  prestige2_requirement: 'Precisa de 15+ prestigios e 100+ 💎', prestige2_confirm: 'Reset profundo por {cores} Nucleos Galacticos?',
  pup_galaxy_mult: 'Multiplicador Galactico', pup_galaxy_mult_desc: 'CPS x1.5 por nível (acumula multiplicativamente)',
  pup_infil_accel: 'Aceleracao de Infiltracao', pup_infil_accel_desc: 'Começar com 100M 🛸 por nível após prestígio',
  pup_tap_enhance: 'Melhoria de Toque', pup_tap_enhance_desc: 'Renda por toque x2 por nível (acumula)',
  pup_offline_expand: 'Expansao Offline', pup_offline_expand_desc: 'Limite recompensa offline +1h/Nv (base 8h)',
  pup_offline_eff: 'Eficiencia Offline', pup_offline_eff_desc: 'Taxa de renda offline +10%p/Nv (base 50%)',
  pup_agent_discount: 'Desconto de Agente', pup_agent_discount_desc: 'Custo de agentes -10% por nível (máx -50%)',
  pup_auto_click: 'Auto Clique', pup_auto_click_desc: 'Auto-toque 3/seg por nível (máx 15/seg)',
  pup_golden_luck: 'Sorte Dourada', pup_golden_luck_desc: 'Recompensa evento dourado +20%/Nv (máx +200%)',
  pup_combo_keep: 'Manter Combo', pup_combo_keep_desc: 'Duração combo +0.5s/Nv (base 2s)',
  pup_quick_start: 'Inicio Rapido', pup_quick_start_desc: 'Receber 1 dos primeiros 5 agentes após prestígio',
  p2up_galaxy_speed: 'Velocidade Galactica', p2up_galaxy_speed_desc: '💎 ganhos x2 por nível no prestígio (acumulável)',
  p2up_auto_prestige: 'Auto Prestigio', p2up_auto_prestige_desc: 'Prestígio automático ao atingir 10B 🛸',
  p2up_permanent: 'Agentes Permanentes', p2up_permanent_desc: 'Manter primeiros 3 tipos de agentes após prestígio',
  p2up_dimension_accel: 'Aceleracao Dimensional', p2up_dimension_accel_desc: 'CPS x5 por nível (acumulável, permanente)',
  p2up_galaxy_memory: 'Memoria Galactica', p2up_galaxy_memory_desc: 'Manter 3 bônus ativos após prestígio',
  p2up_spacetime: 'Curvatura Espacotemporal', p2up_spacetime_desc: 'Taxa de renda offline 100% (permanente)',
  p2up_automate: 'Automacao Galactica', p2up_automate_desc: 'Contratar agentes automaticamente (permanente)',
  rank_e: 'Estagiario', rank_d: 'Agente Junior', rank_c: 'Agente', rank_b: 'Agente Senior',
  rank_a: 'Executivo', rank_s: 'Diretor', rank_ss: 'Comandante Supremo', rank_sss: 'Overlord Galactico',
  ach_title: 'Conquistas', ach_filter_all: 'Todos', ach_filter_tap: 'Toque', ach_filter_resource: 'Recurso',
  ach_filter_producer: 'Produtor', ach_filter_prestige: 'Prestigio', ach_filter_time: 'Tempo',
  ach_filter_special: 'Especial', ach_filter_ad: 'Docs', ach_filter_combo: 'Combo',
  ach_t01: 'Primeiro Passo', ach_t01_reward: '+1 Poder de Toque', ach_t02: 'Aquecimento', ach_t02_reward: '+5% Poder de Toque',
  ach_t03: 'Agente Constante', ach_t03_reward: '+10% Poder de Toque', ach_t04: 'Mestre do Toque', ach_t04_reward: '+15% Poder de Toque',
  ach_t05: 'Determinacao Reptiliana', ach_t05_reward: '+20% Poder de Toque', ach_t06: 'Dedos Galacticos', ach_t06_reward: '+25% Poder de Toque',
  ach_t07: 'Aprendiz de Combo', ach_t07_reward: '+0.5s Combo', ach_t08: 'Mestre do Combo', ach_t08_reward: '+0.5 Limite Combo',
  ach_r01: 'Pequena Intel', ach_r01_reward: '+5% \u{1F6F8}/s', ach_r02: 'Coletor de Intel', ach_r02_reward: '+5% \u{1F6F8}/s',
  ach_r03: 'Cofre Classificado', ach_r03_reward: '+5% \u{1F6F8}/s', ach_r04: 'Infiltracao Milionaria', ach_r04_reward: '+10% \u{1F6F8}/s',
  ach_r05: 'Agente Bilionario', ach_r05_reward: '+10% \u{1F6F8}/s', ach_r06: 'Ops Trilhao', ach_r06_reward: '+15% \u{1F6F8}/s',
  ach_r07: 'Imperio Quatrilhao', ach_r07_reward: '+15% \u{1F6F8}/s', ach_r08: 'Oceano Galactico', ach_r08_reward: '+20% \u{1F6F8}/s',
  ach_r09: 'Universo Cosmico', ach_r09_reward: '+20% \u{1F6F8}/s', ach_r10: 'Infiltracao Infinita', ach_r10_reward: '+30% \u{1F6F8}/s',
  ach_g01: 'Primeiro Recruta', ach_g01_reward: 'Informante x1.5', ach_g02: 'Rede de Intel', ach_g02_reward: 'Informante x2',
  ach_g03: 'Hackear Comecou', ach_g03_reward: 'Hacker x2', ach_g04: 'Legiao Cyber', ach_g04_reward: 'Hacker x3',
  ach_g05: 'Mestre do Disfarce', ach_g05_reward: 'Disfarce x2', ach_g06: 'Rede de Lavagem', ach_g06_reward: 'Controle Mental x2',
  ach_g07: 'Ciencia Louca', ach_g07_reward: 'Lab. Secreto x2', ach_g08: 'Controle de Midia', ach_g08_reward: 'Celula de Midia x2',
  ach_g09: 'Gabinete Sombra', ach_g09_reward: 'Gov. Sombra x2', ach_g10: 'Imperio Subterraneo', ach_g10_reward: 'Base Profunda x2',
  ach_g11: 'Dominio Orbital', ach_g11_reward: 'Estacao Orbital x2', ach_g12: 'Mestre da Galaxia', ach_g12_reward: '\u{1F6F8}/s Total x2',
  ach_p01: 'Primeira Reestruturacao', ach_p01_reward: '+5 💎 Bonus', ach_p02: 'Gosto do Ciclo', ach_p02_reward: '+10% 💎',
  ach_p03: 'Veterano', ach_p03_reward: '+10% 💎', ach_p04: 'Viciado em Prestigio', ach_p04_reward: '+15% 💎',
  ach_p05: 'Loop Infinito', ach_p05_reward: '+20% 💎', ach_p06: 'Memoria Galactica', ach_p06_reward: '+25% 💎',
  ach_p07: 'Reestruturacao Galactica', ach_p07_reward: '+3 🔮 Bonus', ach_p08: 'Senhor Dimensional', ach_p08_reward: '+20% 🔮',
  ach_h01: 'Novo Recruta', ach_h01_reward: 'Bonus Boas-vindas 100 🛸', ach_h02: 'Turno de 1 Hora', ach_h02_reward: '+5% \u{1F6F8}/s',
  ach_h03: 'Meio Dia', ach_h03_reward: '+10% \u{1F6F8}/s', ach_h04: 'Vigia 24h', ach_h04_reward: 'Offline +2h',
  ach_h05: 'Missao de 3 Dias', ach_h05_reward: '\u{1F6F8}/s x1.5', ach_h06: 'Infiltracao Semanal', ach_h06_reward: '\u{1F6F8}/s x2',
  ach_s01: 'Humano Suspeito', ach_s01_reward: '1 Doc', ach_s02: 'Inicio Limpo', ach_s02_reward: 'Titulo: Agente Temerario',
  ach_s03: 'Tudo Dentro', ach_s03_reward: '+10% \u{1F6F8}/s', ach_s04: 'Speed Run', ach_s04_reward: '+10 💎 Bonus',
  ach_s05: 'Cacador Dourado', ach_s05_reward: 'Freq evento -20%', ach_s06: 'Agente Noturno', ach_s06_reward: '\u{1F6F8}/s noturno x1.5',
  ach_s07: 'Guerreiro F2P', ach_s07_reward: 'Recompensa ad +30%', ach_s08: 'Colecionador', ach_s08_reward: '\u{1F6F8}/s x3',
  ach_a01: 'Iniciante em Ads', ach_a01_reward: '1 Doc', ach_a02: 'Entusiasta de Ads', ach_a02_reward: '2 Docs',
  ach_a03: 'Mestre de Ads', ach_a03_reward: 'Recompensa ad +30%', ach_a04: 'Coletor de Docs', ach_a04_reward: 'Efeito doc +20%',
  ach_a05: 'Especialista em Docs', ach_a05_reward: 'Efeito doc +50%',
  ach_c01: 'Inicio Combo', ach_c01_reward: '+0.3s Combo', ach_c02: 'No Ritmo', ach_c02_reward: '+0.1 Mult Combo',
  ach_c03: 'Iniciante Dourado', ach_c03_reward: 'Recompensa evento +10%', ach_c04: 'Coletor Dourado', ach_c04_reward: 'Freq evento -10%',
  ach_c05: 'Maniaco Diario', ach_c05_reward: 'Recompensa missao +50%',
  golden_intel_leak: 'Vazamento de Intel!', golden_agent_frenzy: 'Frenesi de Agentes!', golden_money_launder: 'Lavagem de Dinheiro!',
  golden_facility_boost: 'Sobrecarga!', golden_supply_drop: 'Suprimento Galactico!', golden_touch: 'TOQUE!',
  golden_ad_double: 'Ver anuncio para 2x',
  offline_title: 'Relatorio de Ausencia', offline_elapsed: 'Tempo decorrido', offline_earned: '🛸 ganho',
  offline_cap: 'Max {h}h aplicado', offline_claim: 'Resgatar', offline_double: 'Ver anuncio para 2x ({amount})',
  offline_hours: '{h}h {m}m',
  settings_title: 'Configuracoes', settings_bgm: 'BGM', settings_sfx: 'SFX', settings_lang: 'Idioma',
  settings_reset: 'Resetar Jogo', settings_reset_confirm: 'Apagar TODO o progresso?',
  settings_stats: 'Estatisticas', settings_total_ip: '🛸 Total Ganho', settings_total_taps: 'Toques Totais',
  settings_total_prestiges: 'Prestigios Totais', settings_play_time: 'Tempo Total', settings_docs_shop: 'Loja de Docs',
  doc_shop_title: 'Loja de Docs Classificados',
  doc_ip_boost: 'Acelerador de Renda', doc_ip_boost_desc: '2x producao 🛸/s por 30 seg',
  doc_mega_tap: 'Treino de Toque Forte', doc_mega_tap_desc: '3x renda de toque por 30 seg',
  doc_auto_click: 'Auto-Infiltrador', doc_auto_click_desc: 'Auto-toque 10/seg por 30 seg',
  doc_instant_golden: 'Chamada Dourada', doc_instant_golden_desc: 'Ativar evento dourado instantaneamente',
  doc_timeskip: 'Acelerador Temporal', doc_timeskip_desc: 'Obter 2 horas de renda 🛸 instantaneamente',
  doc_prestige_boost: 'Amplificador Galactico', doc_prestige_boost_desc: '2x 💎 no proximo prestigio',
  doc_prestige_boost_active: '💎 x2 pendente para proximo prestigio', doc_prestige_boost_active_badge: '✅ Ativo',
  ad_offline_double: 'Dobro da recompensa offline', ad_cps_boost: 'Renda/s x10 Boost (15s)',
  ad_prestige_bonus: 'Prestigio +50% 💎', ad_timeskip: 'Salto Temporal (2h)', ad_free_docs: 'Docs Gratis',
  ad_golden_double: 'Dobro recompensa dourada', ad_start_boost: 'Pack de Inicio',
  ad_watching: 'Carregando anuncio...', ad_cooldown: 'Disponivel em {t}',
  settings_sfx_test: 'Testar SFX', settings_sound_reset: 'Redefinir', settings_sound_reset_done: 'Som redefinido',
  num_k: 'K', num_m: 'M', num_b: 'B', num_t: 'T', num_qa: 'Qa', num_qi: 'Qi', num_sx: 'Sx', num_sp: 'Sp', num_oc: 'Oc', num_no: 'No', num_dc: 'Dc',
  mission_title: 'Missoes Diarias',
  mission_claim: 'Resgatar',
  mission_all_complete: 'Bonus Completo!',
  mission_clear_label: 'MISS\u00C3O',
  mission_all_clear_label: 'COMPLETO',
  ach_unlock_label: 'CONQUISTA',
  mission_diff_easy: 'Facil',
  mission_diff_normal: 'Medio',
  mission_diff_hard: 'Dificil',
  mission_tap_100: 'Toque Leve',
  mission_tap_100_desc: 'Tocar 100 vezes',
  mission_tap_300: 'Maos Quentes',
  mission_tap_300_desc: 'Tocar 300 vezes',
  mission_buy_5: 'Pequeno Recruta',
  mission_buy_5_desc: 'Comprar 5 produtores',
  mission_combo_10: 'Inicio Combo',
  mission_combo_10_desc: 'Alcancar 10 combo',
  mission_golden_1: 'Sorte Grande',
  mission_golden_1_desc: 'Pegar 1 evento dourado',
  mission_tap_1000: 'Mao Pesada',
  mission_tap_1000_desc: 'Tocar 1.000 vezes',
  mission_buy_20: 'Construtor de Esquadrao',
  mission_buy_20_desc: 'Comprar 20 produtores',
  mission_combo_50: 'Combo Pro',
  mission_combo_50_desc: 'Alcancar 50 combo',
  mission_golden_3: 'Corrida do Ouro',
  mission_golden_3_desc: 'Pegar 3 eventos dourados',
  mission_earn_1m: 'Ops Milhao',
  mission_earn_1m_desc: 'Ganhar 1M 🛸',
  mission_tap_5000: 'Maquina de Toques',
  mission_tap_5000_desc: 'Tocar 5.000 vezes',
  mission_buy_50: 'Construtor de Exercito',
  mission_buy_50_desc: 'Comprar 50 produtores',
  mission_combo_100: 'Deus do Combo',
  mission_combo_100_desc: 'Alcancar 100 combo',
  mission_golden_5: 'Mestre Dourado',
  mission_golden_5_desc: 'Pegar 5 eventos dourados',
  mission_earn_1b: 'Agente Bilionario',
  mission_earn_1b_desc: 'Ganhar 1B 🛸',
  mission_tap_200: 'Dedos rápidos',
  mission_tap_200_desc: 'Toque 200 vezes',
  mission_buy_3: 'Primeiros recrutas',
  mission_buy_3_desc: 'Compre 3 produtores',
  mission_combo_15: 'Combo iniciante',
  mission_combo_15_desc: 'Alcance 15 combo',
  mission_earn_10k: 'Dinheiro de bolso',
  mission_earn_10k_desc: 'Ganhe 10K 🛸',
  mission_earn_100k: 'Arrecadador',
  mission_earn_100k_desc: 'Ganhe 100K 🛸',
  mission_tap_500: 'Toque constante',
  mission_tap_500_desc: 'Toque 500 vezes',
  mission_tap_700: 'Imparável',
  mission_tap_700_desc: 'Toque 700 vezes',
  mission_buy_10: 'Líder de equipe',
  mission_buy_10_desc: 'Compre 10 produtores',
  mission_combo_30: 'Corrente de combo',
  mission_combo_30_desc: 'Alcance 30 combo',
  mission_golden_2: 'Ouro duplo',
  mission_golden_2_desc: 'Pegue 2 eventos dourados',
  mission_tap_3000: 'Guerreiro do toque',
  mission_tap_3000_desc: 'Toque 3.000 vezes',
  mission_buy_30: 'Batalhão',
  mission_buy_30_desc: 'Compre 30 produtores',
  mission_combo_75: 'Combo elite',
  mission_combo_75_desc: 'Alcance 75 combo',
  mission_golden_4: 'Caçador de ouro',
  mission_golden_4_desc: 'Pegue 4 eventos dourados',
  mission_earn_10m: 'Magnata',
  mission_earn_10m_desc: 'Ganhe 10M 🛸',

  // Conquest
  cq_title: 'Conquista Mundial',
  cq_progress: 'Conquistado',
  cq_infiltration_power: 'Poder de Infiltração',
  cq_active_conquest: 'Infiltrando',
  cq_infiltration_progress: 'Progresso de Infiltração',
  cq_time_remaining: 'Tempo estimado',
  cq_start_infiltration: 'Iniciar Infiltração',
  cq_stop_infiltration: 'Parar Infiltração',
  cq_no_power_hint: 'Contrate agentes para gerar poder de infiltração',
  cq_locked: 'Bloqueado',
  cq_available: 'Disponível',
  cq_conquered: 'Conquistado',
  cq_popup_title: 'Conquista Completa!',
  cq_popup_desc: 'foi conquistado! Construa instalações para ficar mais forte.',
  cq_back: 'Voltar',
  cq_invest_title: 'Investir 🛸 para conquistar',
  cq_current_ip: '🛸 atual',
  cq_facilities: 'Instalações',
  cq_build: 'Construir',
  cq_upgrade: 'Melhorar',
  cq_next_level: 'Próximo',
  cq_counter_intel_title: 'Alerta de contraespionagem!',
  cq_counter_intel_text: 'Sua infiltração em {country} foi detectada! O progresso será reduzido.',
  cq_defend_ad: 'Assistir anúncio para defender',
  cq_accept_loss: 'Aceitar perda',
  cq_ending_title: 'Terra conquistada!',
  cq_ending_text: 'A conspiração reptiliana está completa. Todas as nações se curvam ao império das sombras.',
  cq_ending_time: 'Tempo de jogo',
  cq_ending_prestiges: 'Prestígios',
  cq_ending_total_ip: '🛸 total',
  cq_ending_taps: 'Toques totais',
  cq_ending_continue: 'Continuar jogando',
  cq_egypt: 'Egito', cq_egypt_desc: 'Bases antigas das pirâmides',
  cq_brazil: 'Brasil', cq_brazil_desc: 'Esconderijos na selva amazônica',
  cq_india: 'Índia', cq_india_desc: 'Infiltração do culto Naga',
  cq_australia: 'Austrália', cq_australia_desc: 'Bunkers subterrâneos do deserto',
  cq_japan: 'Japão', cq_japan_desc: 'Roubo de tecnologia',
  cq_korea: 'Coreia', cq_korea_desc: 'Brecha ciberdefesa NIS',
  cq_uk: 'Reino Unido', cq_uk_desc: 'Infiltração real MI5/MI6',
  cq_russia: 'Rússia', cq_russia_desc: 'Operações siberianas FSB',
  cq_china: 'China', cq_china_desc: 'Vigilância mais forte do mundo',
  cq_usa: 'Estados Unidos', cq_usa_desc: 'CIA/NSA chefe final',
  fac_pyramid_vault: 'Cofre Pirâmide', fac_pyramid_vault_d: '\u{1F6F8}/s +5% por nível',
  fac_nile_network: 'Rede do Nilo', fac_nile_network_d: 'Offline +5% por nível',
  fac_ancient_lab: 'Lab Antigo', fac_ancient_lab_d: 'TAP +10% por nível',
  fac_amazon_hideout: 'Esconderijo Amazônico', fac_amazon_hideout_d: 'Desconto +2% por nível',
  fac_samba_broadcast: 'Transmissão Samba', fac_samba_broadcast_d: '\u{1F6F8}/s +8% por nível',
  fac_jungle_lab: 'Lab da Selva', fac_jungle_lab_d: 'Golden +5% por nível',
  fac_naga_temple: 'Templo Naga', fac_naga_temple_d: '💎 +5% por nível',
  fac_bollywood_studio: 'Estúdio Bollywood', fac_bollywood_studio_d: 'Offline +8% por nível',
  fac_caste_network: 'Rede de Castas', fac_caste_network_d: '\u{1F6F8}/s +12% por nível',
  fac_desert_bunker: 'Bunker do Deserto', fac_desert_bunker_d: 'TAP +15% por nível',
  fac_ayers_signal: 'Sinal Ayers', fac_ayers_signal_d: 'Golden +8% por nível',
  fac_outback_base: 'Base Outback', fac_outback_base_d: '\u{1F6F8}/s +15% por nível',
  fac_akiba_ai: 'IA Akihabara', fac_akiba_ai_d: '\u{1F6F8}/s +20% por nível',
  fac_ninja_intel: 'Intel Ninja', fac_ninja_intel_d: 'Desconto +3% por nível',
  fac_tokyo_tower: 'Torre de Tóquio', fac_tokyo_tower_d: '💎 +8% por nível',
  fac_gangnam_hq: 'QG Gangnam', fac_gangnam_hq_d: '\u{1F6F8}/s +25% por nível',
  fac_cyber_command: 'Comando Cibernético', fac_cyber_command_d: 'TAP +25% por nível',
  fac_kpop_brainwash: 'Lavagem K-Pop', fac_kpop_brainwash_d: '💎 +10% por nível',
  fac_royal_infiltrate: 'Infiltração Real', fac_royal_infiltrate_d: '\u{1F6F8}/s +30% por nível',
  fac_london_tower: 'Torre de Londres', fac_london_tower_d: 'Offline +15% por nível',
  fac_mi6_double: 'Agente Duplo MI6', fac_mi6_double_d: 'Golden +12% por nível',
  fac_siberia_base: 'Base Sibéria', fac_siberia_base_d: '\u{1F6F8}/s +40% por nível',
  fac_kgb_remnant: 'Remanescente KGB', fac_kgb_remnant_d: 'Desconto +5% por nível',
  fac_nuke_bunker: 'Bunker Nuclear', fac_nuke_bunker_d: 'TAP +40% por nível',
  fac_great_wall: 'Grande Firewall', fac_great_wall_d: '\u{1F6F8}/s +50% por nível',
  fac_shenzhen_factory: 'Fábrica Shenzhen', fac_shenzhen_factory_d: 'Desconto +8% por nível',
  fac_panda_spy: 'Rede Espião Panda', fac_panda_spy_d: 'Golden +20% por nível',
  fac_area51: 'Área 51', fac_area51_d: '\u{1F6F8}/s +80% por nível',
  fac_pentagon: 'Pentágono', fac_pentagon_d: 'TAP +80% por nível',
  fac_wall_street: 'Wall Street', fac_wall_street_d: '💎 +25% por nível',

  buy: 'Comprar', max: 'MAX', level: 'Nv.', locked: 'Bloqueado', unlocked: 'Desbloqueado',
  upgrade_locked_prev: 'Aprenda a melhoria anterior primeiro',
  condition: 'Condicao', cost: 'Custo', owned: 'Possuido', effect: 'Efeito', reward: 'Recompensa',
  close: 'Fechar', confirm: 'Confirmar', cancel: 'Cancelar',

  // Conquest achievements
  ach_filter_conquest: 'Conquista',
  ach_q01: 'Primeira Conquista', ach_q01_reward: '\u{1F6F8}/s +10%',
  ach_q02: 'Tripla Ameaça', ach_q02_reward: 'TAP +10%',
  ach_q03: 'Metade do Mundo', ach_q03_reward: '💎 +15%',
  ach_q04: 'Sete Bandeiras', ach_q04_reward: 'Offline +20%',
  ach_q05: 'Dominador Mundial', ach_q05_reward: '\u{1F6F8}/s x3',
  ach_q06: 'Mestre de Instalações', ach_q06_reward: '\u{1F6F8}/s x2',
  milestone_next: 'Próximo',
  settings_conquest: 'Conquista',

  // Currency info
  currency_ip_name: 'Pontos de Infiltração (IP)',
  currency_ip_earn: 'Toque, produção automática, renda offline e recompensas de anúncios',
  currency_ip_use: 'Contratar agentes, comprar melhorias, investir em conquistas',
  currency_gc_name: 'Créditos Galácticos (GC)',
  currency_gc_earn: 'Ao fazer prestige (Reestruturação) com base no IP total acumulado',
  currency_gc_use: 'Comprar melhorias de prestige (multiplicador de produ\u00E7\u00E3o, eficiência offline, etc.)',
  currency_cores_name: 'Núcleos Galácticos',
  currency_cores_earn: 'Ao fazer 2º prestige (Reestruturação Galáctica) com base no GC total',
  currency_cores_use: 'Comprar melhorias de 2º prestige (buffs permanentes, automação, etc.)',
  currency_docs_name: 'Documentos Classificados',
  currency_docs_earn: 'Missões diárias, assistir anúncios ou desbloquear conquistas',
  currency_docs_use: 'Comprar boosts poderosos na Loja de Docs (aba Missão)',
  currency_how_earn: 'Como obter',
  currency_how_use: 'Como usar',

  // Prestige upgrades - conquest
  pup_infiltration_mastery: 'Maestria de Infiltração',
  pup_infiltration_mastery_desc: 'Poder de infiltração total +50%/Nv (máx +500%)',
  pup_agent_network: 'Rede de Agentes',
  pup_agent_network_desc: 'Infiltração +5% por 100 agentes por nível',
  pup_quick_infiltration: 'Infiltração em Cadeia',
  pup_quick_infiltration_desc: 'Ao conquistar: próximo país +10% progresso/Nv',
  pup_critical_chance: 'Treinamento Crítico',
  pup_critical_chance_desc: 'Chance de crítico +3%/Nv (base 10%, máx 50%)',
  pup_critical_damage: 'Poder Crítico',
  pup_critical_damage_desc: 'Dano crítico +1x/Nv (base x3)',

  // Special upgrades - conquest
  special_spy_master: 'Mestre Espião',
  special_spy_master_desc: 'Poder de infiltração total x2',

  ad_income_x5: 'Renda de 30min',
  ad_income_x5_desc: 'Assista um anúncio para receber\n{amount} 🛸 instantaneamente (30 minutos de renda)!',
  ad_tap_x10: 'Toque x10 (10s)',
  ad_tap_x10_desc: 'Assista um anúncio para aumentar\na renda por toque x10 por 10 segundos!',
  ad_free_docs_desc: 'Assista um anúncio para receber\n1 Documento Classificado 📜 grátis!',
  ad_prestige_desc: 'Assista um anúncio para aumentar\nsua renda x10 por 15 segundos!',
  cq_tutorial_title: '🌍 Guia de Conquista Mundial',
  cq_tutorial_text: 'Após conquistar um país, você pode construir <b>instalações</b>!\nAtualize-as para bônus permanentes como\n<b>RPS, renda por toque, renda offline</b> e mais.\n\nContrate agentes para aumentar o poder de infiltração.',
  rank_promote: 'Promover',
  rank_promoted: 'Promoção concluída!',

  // Boss events
  boss_resistance_captain: 'Capitão da Resistência',
  boss_resistance_captain_desc: 'Líder da milícia humana, veterano de combate',
  boss_cia_agent: 'Agente da CIA',
  boss_cia_agent_desc: 'Operativo secreto com intel classificada',
  boss_mib_investigator: 'Investigador MIB',
  boss_mib_investigator_desc: 'Agente de campo do Men In Black',
  boss_un_inspector: 'Inspetor da ONU',
  boss_un_inspector_desc: 'Caçador de conspirações internacionais',
  boss_whistleblower: 'Denunciante',
  boss_whistleblower_desc: 'Infiltrado rebelde com provas',
  boss_journalist: 'Jornalista Investigativo',
  boss_journalist_desc: 'Incansável buscador da verdade com câmera',
  boss_truth_seeker: 'Buscador da Verdade',
  boss_truth_seeker_desc: 'Pesquisador paranormal na trilha',
  boss_galactic_guardian: 'Guardião Galáctico',
  boss_galactic_guardian_desc: 'Executor cósmico da lei universal',

  boss_alert: 'AMEAÇA DETECTADA!',
  boss_alert_desc: 'Um inimigo apareceu! Toque para atacar!',
  boss_hp: 'HP',
  boss_tap_attack: 'TOQUE PARA ATACAR!',
  boss_double_damage: '2x DANO (30s)',
  boss_eliminated: 'ELIMINADO!',
  boss_eliminated_desc: '{name} foi neutralizado!',
  boss_reward_ip: '+{amount} IP',
  boss_reward_docs: '+{amount} Docs',
  boss_reward_gc: '+{amount} GC',
  boss_reward_boost: 'CPS x3 ({seconds}s)',
  boss_claim: 'Receber Recompensa',
  boss_claim_double: '2x Recompensa',
  boss_escaped: 'ESCAPOU!',
  boss_escaped_desc: 'O alvo fugiu...',
  boss_revive: 'Tentar novamente (+20s)',
  boss_phase2: 'ENFURECIDO!',
  boss_streak: 'Sequência: {n}',
  boss_time_remaining: 'Tempo',
  boss_double_damage_active: '2x DANO Ativo!',

  // Agent collection
  tab_agent: 'Agentes',
  agent_collection_title: 'Coleção de Agentes',
  agent_equipped: 'Equipado',
  agent_empty_slot: 'Vazio',
  agent_obtained: 'Agente Obtido!',
  agent_equip: 'Equipar',
  agent_unequip: 'Desequipar',
  agent_locked: '???',
  agent_count: 'x{n}',
  agent_tutorial_title: 'Guia de Colecao de Agentes',
  agent_tutorial_text: 'Derrote os <b>chefes</b> para colecionar cartas de agentes!<br><br>Cada agente tem um bonus passivo unico.<br>Toque na carta para equipar agentes.<br><br>Maior raridade = efeitos mais fortes.<br>O prestigio desbloqueia mais slots de equipamento.',

  // Agent effect descriptions
  agent_effect_cps_pct: 'CPS {n}',
  agent_effect_tap_pct: 'TAP {n}',
  agent_effect_conquest_speed: 'Vel. Conquista {n}',
  agent_effect_boss_damage: 'Dano ao Chefe {n}',
  agent_effect_golden_chance: 'Evento Dourado {n}',
  agent_effect_offline_pct: 'Renda Offline {n}',
  agent_effect_docs_rate: 'Taxa de Docs {n}',
  agent_effect_gc_pct: 'Ganho GC {n}',
  agent_effect_boss_spawn_reduce: 'Aparição Chefe -{n}',
  agent_effect_prestige_gc_bonus: 'Prestígio GC {n}',
  agent_effect_faction_favor: 'Favor da Facção {n}',

  // Agent names & descriptions (25 agents)
  // Common (10)
  agent_field_spy: 'Espião de Campo',
  agent_field_spy_desc: 'Inteligência de campo aumenta produção IP +8%',
  agent_code_cracker: 'Decodificador',
  agent_code_cracker_desc: 'Habilidade de decifração aumenta poder de toque +10%',
  agent_shadow_runner: 'Corredor das Sombras',
  agent_shadow_runner_desc: 'Perícia em furtividade acelera conquista +10%',
  agent_data_miner: 'Minerador de Dados',
  agent_data_miner_desc: 'Coleta de dados aumenta renda offline +15%',
  agent_lookout: 'Sentinela',
  agent_lookout_desc: 'Olhos aguçados aumentam chance de evento dourado +10%',
  agent_doc_thief: 'Ladrão de Docs',
  agent_doc_thief_desc: 'Furto de documentos aumenta aquisição de docs +15%',
  agent_network_bot: 'Bot de Rede',
  agent_network_bot_desc: 'Redes automatizadas aumentam CPS +10%',
  agent_safe_cracker: 'Arrombador de Cofres',
  agent_safe_cracker_desc: 'Habilidade com cofres aumenta poder de toque +12%',
  agent_recruit: 'Recruta',
  agent_recruit_desc: 'Lutador novato aumenta dano ao chefe +10%',
  agent_comm_officer: 'Oficial de Comunicações',
  agent_comm_officer_desc: 'Comunicações aumentam favor da facção +10%',

  // Rare (8)
  agent_infiltration_ace: 'Ás da Infiltração',
  agent_infiltration_ace_desc: 'Infiltrador de elite aumenta CPS +20%',
  agent_mind_bender: 'Dobra-Mentes',
  agent_mind_bender_desc: 'Poderes psíquicos aceleram conquista +25%',
  agent_vault_raider: 'Invasor de Cofres',
  agent_vault_raider_desc: 'Perícia em cofres aumenta ganho GC +20%',
  agent_signal_jammer: 'Bloqueador de Sinal',
  agent_signal_jammer_desc: 'Bloqueio reduz intervalo de aparição do chefe -15%',
  agent_double_agent: 'Agente Duplo',
  agent_double_agent_desc: 'Lealdade dupla aumenta renda offline +30%',
  agent_hive_mind: 'Mente Colmeia',
  agent_hive_mind_desc: 'Consciência coletiva aumenta taxa de docs +25%',
  agent_boss_hunter: 'Caçador de Chefes',
  agent_boss_hunter_desc: 'Rastreador especializado aumenta dano ao chefe +25%',
  agent_faction_liaison: 'Ligação da Facção',
  agent_faction_liaison_desc: 'Laços diplomáticos aumentam favor da facção +25%',

  // Epic (5)
  agent_reptilian_elite: 'Elite Reptiliana',
  agent_reptilian_elite_desc: 'Guerreiro de elite aumenta CPS +35%',
  agent_galaxy_commander: 'Comandante Galáctico',
  agent_galaxy_commander_desc: 'Autoridade galáctica aumenta ganho GC +40%',
  agent_dark_secretary: 'Secretário Sombrio',
  agent_dark_secretary_desc: 'Burocrata das sombras aumenta prestígio GC +20%',
  agent_omega_operative: 'Operativo Ômega',
  agent_omega_operative_desc: 'Lutador supremo aumenta dano ao chefe +50%',
  agent_shapeshifter: 'Metamorfo',
  agent_shapeshifter_desc: 'Mestre das formas aumenta poder de toque +40%',

  // Legendary (2)
  agent_the_overlord: 'O Soberano',
  agent_the_overlord_desc: 'Comandante supremo aumenta todo CPS +50%',
  agent_grand_architect: 'Grande Arquiteto',
  agent_grand_architect_desc: 'Planejador cósmico acelera conquista +60%',

  // Faction system
  faction_status_title: 'Status da Faccao',
  faction_favorability: 'Favorabilidade',
  faction_tier: 'Nivel {n}',

  // Faction event popup
  faction_event_help: 'Ajudar',
  faction_event_ignore: 'Ignorar',
  faction_event_timer: '{seconds}s restantes',
  faction_event_reward: '+{favor} favor {faction}, -{loss} favor {target}',
  faction_event_ip_reward: '+{amount} recompensa IP',
  faction_event_ad_bonus: 'Ver Anuncio: +{n} favor {faction}',

  // Faction names
  faction_illuminati: 'Illuminati',
  faction_illuminati_desc: 'Governantes humanos secretos manipulando tudo nas sombras',
  faction_grey: 'Alienigenas Cinzentos',
  faction_grey_desc: 'Especie extraterrestre que compartilha tecnologia',
  faction_mib: 'Resistencia MIB',
  faction_mib_desc: 'Organizacao humana secreta combatendo influencia alienigena',

  // Faction bonus descriptions
  faction_illuminati_bonus1: 'CPS +10%',
  faction_illuminati_bonus2: 'CPS +15%',
  faction_illuminati_bonus3: 'Vel. Conquista +20%',
  faction_grey_bonus1: 'Toque +15%',
  faction_grey_bonus2: 'Toque +20%',
  faction_grey_bonus3: 'Cookie Dourado +25%',
  faction_mib_bonus1: 'Dano ao Chefe +20%',
  faction_mib_bonus2: 'Renda Offline +15%',
  faction_mib_bonus3: 'Aparicao de Chefe -15%',

  // Event titles and descriptions
  event_illu_decode_title: 'Interceptacao Classificada',
  event_illu_decode_desc: 'Os Illuminati estao interceptando arquivos governamentais classificados. Ajudar a decodificar?',
  event_illu_stock_title: 'Manipulacao de Mercado',
  event_illu_stock_desc: 'Os Illuminati querem manipular os mercados de acoes globais. Fornecer informacoes privilegiadas?',
  event_illu_surveillance_title: 'Rede de Vigilancia',
  event_illu_surveillance_desc: 'Os Illuminati estao construindo uma rede secreta de vigilancia. Ajudar na construcao?',
  event_illu_meeting_title: 'Cupula Secreta',
  event_illu_meeting_desc: 'Uma reuniao secreta dos Illuminati em um encontro de lideres mundiais. Fornecer seguranca?',
  event_illu_bribe_title: 'Diplomacia Alienigena',
  event_illu_bribe_desc: 'Os Illuminati querem subornar um diplomata alienigena. Entregar o pacote?',

  event_grey_experiment_title: 'Pesquisa Humana',
  event_grey_experiment_desc: 'Os Alienigenas Cinzentos estao conduzindo experimentos em humanos. Guardar o laboratorio?',
  event_grey_mindcontrol_title: 'Dispositivo de Controle Mental',
  event_grey_mindcontrol_desc: 'Os Alienigenas Cinzentos querem instalar um dispositivo de controle mental em uma cidade. Ajudar a construir?',
  event_grey_crash_title: 'Recuperacao de Queda',
  event_grey_crash_desc: 'Uma nave batedora Cinzenta caiu no deserto. Ajudar a recuperar a tripulacao?',
  event_grey_terraform_title: 'Terraformacao Secreta',
  event_grey_terraform_desc: 'Os Alienigenas Cinzentos estao secretamente terraformando uma ilha. Fornecer recursos?',
  event_grey_hack_title: 'Invasao de Satelite',
  event_grey_hack_desc: 'Os Alienigenas Cinzentos querem hackear a rede de satelites da Terra. Fornecer codigos de acesso?',

  event_mib_raid_title: 'Ataque ao Posto Alienigena',
  event_mib_raid_desc: 'O MIB esta planejando um ataque a um posto alienigena. Juntar-se ao assalto?',
  event_mib_safehouse_title: 'Descoberta de Esconderijo',
  event_mib_safehouse_desc: 'O MIB descobriu um esconderijo secreto dos Illuminati. Ajudar no ataque?',
  event_mib_weapons_title: 'Desenvolvimento de Armas',
  event_mib_weapons_desc: 'O MIB esta desenvolvendo armas anti-alienigenas. Fornecer materiais raros?',
  event_mib_evacuate_title: 'Evacuacao de Civis',
  event_mib_evacuate_desc: 'O MIB precisa evacuar civis de uma zona de ataque alienigena. Ajudar?',
  event_mib_expose_title: 'Corrupcao Exposta',
  event_mib_expose_desc: 'O MIB quer expor a corrupcao dos Illuminati ao publico. Vazar os documentos?',

  // Shadow Contact (mid-game ad choices)
  sc_title: 'Contato nas Sombras',
  sc_accept: 'Aceitar Acordo',
  sc_decline: 'Recusar',
  sc_offer_intel: 'Relatorio de Inteligencia',
  sc_offer_intel_desc: 'Um espiao infiltrado oferece intel confidencial no valor de {amount} 🛸',
  sc_offer_serum: 'Soro Experimental',
  sc_offer_serum_desc: 'Uma amostra de laboratorio alien que amplifica o poder de toque x10 por 30 segundos',
  sc_offer_tech: 'Tecnologia do Mercado Negro',
  sc_offer_tech_desc: 'Tecnologia alien roubada que multiplica a renda x10 por 30 segundos',
  sc_offer_docs: 'Esconderijo Confidencial',
  sc_offer_docs_desc: 'Um esconderijo secreto com 3 Documentos Confidenciais 📜',
  boss_warning: 'ALERTA',
  boss_warning_sub: 'Um inimigo poderoso se aproxima...',
  boss_tutorial_title: 'Luta de Chefe!',
  boss_tutorial_text: 'Um chefe apareceu! Toque rápido para causar dano antes do tempo acabar.<br><br>Derrote chefes para ganhar <b>IP, Docs e Cartas de Agente</b>!<br>Assista um anúncio para <b>2x dano</b>.',
  // === Infiltration Run (generated) ===
  tab_infiltration: "Infiltrate",
  infil_eyebrow: "INFILTRATION OPS",
  infil_title: "Infiltration Run",
  infil_subtitle: "Slip in, climb the ranks, get out clean.",
  infil_tutorial_note: "First run: learn the ropes. Chasing the top rank too hard gets you caught.",
  infil_agent_stats: "Agent Stats",
  infil_highest_career: "Best Career",
  infil_total_runs: "Total Runs",
  infil_total_success: "Successes",
  infil_tradeoff_hint: "Safe = small reward, low rank. Greedy = high detection, high risk. Weigh every choice.",
  infil_start: "Start Infiltration",
  infil_start_tutorial: "Start Tutorial Run",
  infil_cooldown: "Cooldown",
  infil_cancel: "Cancel",
  infil_detection: "Detection",
  infil_step: "Event",
  infil_difficulty: "Diff",
  infil_selecting: "Selecting",
  infil_choice_success: "SUCCESS",
  infil_choice_fail: "FAILED",
  infil_roll: "Roll",
  infil_next: "Next",
  infil_to_extraction: "To Extraction",
  infil_extraction_cat: "FINAL STEP",
  infil_extraction_title: "Extraction",
  infil_extraction_desc: "All events cleared. Slip out now — the lower your detection, the safer.",
  infil_attempt_extraction: "Attempt Extraction",
  infil_final_chance: "Extraction Chance",
  infil_result_success: "INFILTRATION SUCCESS",
  infil_result_fail: "CAUGHT",
  infil_result_success_sub: "You slipped out and secured a cover career.",
  infil_result_fail_sub: "Security caught you. Nothing gained this time.",
  infil_docs: "Docs",
  infil_cleared: "Cleared",
  infil_career_earned: "Career Secured",
  infil_fail_note: "No reward. A short cooldown before the next run.",
  infil_retry_ad: "Watch Ad: Second Chance",
  infil_retry_title: "Second Chance",
  infil_retry_desc: "Watch a short ad to lower your detection and retry the extraction once.",
  infil_retry_confirm: "Watch Ad",
  infil_close: "Close",
  infil_stat_disguise: "Disguise",
  infil_stat_combat: "Combat",
  infil_stat_hacking: "Hacking",
  infil_stat_charisma: "Charisma",
  infil_stat_none: "No Check",
  infil_tag_safe: "SAFE",
  infil_tag_risky: "RISKY",
  infil_tag_aggressive: "ALL-IN",
  infil_career_cleaner: "Cleaner",
  infil_career_guard: "Guard",
  infil_career_clerk: "Clerk",
  infil_career_manager: "Manager",
  infil_career_executive: "Executive",
  infil_career_director: "Director",
  infil_career_warrior: "Warrior",
  infil_career_none: "None",
  infil_ev_patrol_cat: "Infiltration Case / Corporate State",
  infil_ev_patrol_title: "Patrol Approaching",
  infil_ev_patrol_desc: "A security patrol is heading straight for you. How do you react?",
  infil_ch_patrol_a_label: "Wait in the shadows",
  infil_ch_patrol_a_desc: "Hold your breath until they pass. Safe, but you lose time.",
  infil_ch_patrol_b_label: "Greet them as staff",
  infil_ch_patrol_b_desc: "Nod politely in your cover identity and walk past.",
  infil_ch_patrol_c_label: "Take them down",
  infil_ch_patrol_c_desc: "Ambush the patrol and force through. Big reward, big risk.",
  infil_ev_security_check_cat: "Infiltration Case / Corporate State",
  infil_ev_security_check_title: "Security Checkpoint",
  infil_ev_security_check_desc: "A manned checkpoint blocks the corridor ahead.",
  infil_ch_security_check_a_label: "Find a side route",
  infil_ch_security_check_a_desc: "Quietly slip down an adjacent passage.",
  infil_ch_security_check_b_label: "Show forged pass",
  infil_ch_security_check_b_desc: "Present a well-made forged access pass.",
  infil_ch_security_check_c_label: "Hack the scanner",
  infil_ch_security_check_c_desc: "Breach the scanner terminal and kill the alarm.",
  infil_ev_informant_cat: "Infiltration Case / Corporate State",
  infil_ev_informant_title: "Recruit an Informant",
  infil_ev_informant_desc: "An insider might hand over classified files — for a price.",
  infil_ch_informant_a_label: "Take the anonymous tip",
  infil_ch_informant_a_desc: "Check the drop box without making contact.",
  infil_ch_informant_b_label: "Persuade the insider",
  infil_ch_informant_b_desc: "Win over the staffer with smooth talk.",
  infil_ch_informant_c_label: "Strong-arm the files",
  infil_ch_informant_c_desc: "Threaten them into surrendering the data.",
  infil_ev_cctv_cat: "Infiltration Case / Corporate State",
  infil_ev_cctv_title: "Bypass the CCTV",
  infil_ev_cctv_desc: "A ceiling of cameras sweeps the whole hall.",
  infil_ch_cctv_a_label: "Move through blind spots",
  infil_ch_cctv_a_desc: "Creep slowly along the camera blind spots.",
  infil_ch_cctv_b_label: "Loop the feed",
  infil_ch_cctv_b_desc: "Splice a fake loop into the surveillance feed.",
  infil_ch_cctv_c_label: "Smash the cameras",
  infil_ch_cctv_c_desc: "Wreck the cameras and rush past.",
  infil_ev_fake_id_cat: "Infiltration Case / Corporate State",
  infil_ev_fake_id_title: "ID Inspection",
  infil_ev_fake_id_desc: "Guards are checking every ID in a long queue.",
  infil_ch_fake_id_a_label: "Leave the queue",
  infil_ch_fake_id_a_desc: "Quietly drop out and find another way.",
  infil_ch_fake_id_b_label: "Present forged ID",
  infil_ch_fake_id_b_desc: "Pass the checkpoint with a crafted forgery.",
  infil_ch_fake_id_c_label: "Sweet-talk the guard",
  infil_ch_fake_id_c_desc: "Talk your way past with slick charm.",
  infil_ev_parking_cat: "Infiltration Case / Corporate State",
  infil_ev_parking_title: "Underground Parking",
  infil_ev_parking_desc: "The garage is your way in, but a guard patrols it.",
  infil_ch_parking_a_label: "Hide behind vehicles",
  infil_ch_parking_a_desc: "Tuck yourself between parked cars.",
  infil_ch_parking_b_label: "Neutralize the guard",
  infil_ch_parking_b_desc: "Silently subdue the garage guard.",
  infil_ch_parking_c_label: "Pose as valet",
  infil_ch_parking_c_desc: "Steal a valet uniform and stroll in.",
  infil_ev_server_room_cat: "Infiltration Case / Corporate State",
  infil_ev_server_room_title: "Server Room Breach",
  infil_ev_server_room_desc: "The core data sits behind a hardened server-room door.",
  infil_ch_server_room_a_label: "Crawl the vents",
  infil_ch_server_room_a_desc: "Take the narrow vents. Slow but safe.",
  infil_ch_server_room_b_label: "Seize admin access",
  infil_ch_server_room_b_desc: "Hijack admin rights to open the room.",
  infil_ch_server_room_c_label: "Force the door",
  infil_ch_server_room_c_desc: "Rip open the security door and barge in.",
  infil_ev_board_meeting_cat: "Infiltration Case / Corporate State",
  infil_ev_board_meeting_title: "Board Meeting Infiltration",
  infil_ev_board_meeting_desc: "Top executives are trading secrets behind closed doors.",
  infil_ch_board_meeting_a_label: "Eavesdrop from the hall",
  infil_ch_board_meeting_a_desc: "Listen quietly from outside the room.",
  infil_ch_board_meeting_b_label: "Pose as consultant",
  infil_ch_board_meeting_b_desc: "Blend in as an outside consultant.",
  infil_ch_board_meeting_c_label: "Storm the room",
  infil_ch_board_meeting_c_desc: "Raid the room and seize every secret. Warrior play.",
  infil_ev_reporter_cat: "Infiltration Case / Corporate State",
  infil_ev_reporter_title: "Shake the Reporter",
  infil_ev_reporter_desc: "A dogged journalist is tailing your every move.",
  infil_ch_reporter_a_label: "Blend into the crowd",
  infil_ch_reporter_a_desc: "Melt into a busy street to lose the tail.",
  infil_ch_reporter_b_label: "Change disguise",
  infil_ch_reporter_b_desc: "Swap outerwear and reverse direction.",
  infil_ch_reporter_c_label: "Feed false leads",
  infil_ch_reporter_c_desc: "Approach first and plant fake information.",
  infil_ev_party_cat: "Infiltration Case / Corporate State",
  infil_ev_party_title: "Crash the Party",
  infil_ev_party_desc: "A gala hides the people you need to reach.",
  infil_ch_party_a_label: "Carry a waiter tray",
  infil_ch_party_a_desc: "Grab an empty tray and pose as service.",
  infil_ch_party_b_label: "Pose as a guest",
  infil_ch_party_b_desc: "Mingle smoothly as an invited guest.",
  infil_ch_party_c_label: "Enter as a VIP",
  infil_ch_party_c_desc: "Dress as a VIP and stride through the front.",
  infil_ev_drone_cat: "Infiltration Case / Corporate State",
  infil_ev_drone_title: "Drone Surveillance",
  infil_ev_drone_desc: "A surveillance drone sweeps the open yard.",
  infil_ch_drone_a_label: "Wait under cover",
  infil_ch_drone_a_desc: "Hide beneath a structure until it passes.",
  infil_ch_drone_b_label: "Jam the signal",
  infil_ch_drone_b_desc: "Jam its comms and blind the drone.",
  infil_ch_drone_c_label: "Shoot it down",
  infil_ch_drone_c_desc: "Down the drone. Sure, but it leaves traces.",
  infil_ev_guard_shift_cat: "Infiltration Case / Corporate State",
  infil_ev_guard_shift_title: "Guard Shift Change",
  infil_ev_guard_shift_desc: "A shift change opens a brief window in the watch.",
  infil_ch_guard_shift_a_label: "Wait for the swap",
  infil_ch_guard_shift_a_desc: "Wait for the gap and move on the change.",
  infil_ch_guard_shift_b_label: "Pose as relief guard",
  infil_ch_guard_shift_b_desc: "Walk into the post as the relief guard.",
  infil_ch_guard_shift_c_label: "Ambush the guard",
  infil_ch_guard_shift_c_desc: "Jump the guard just before the swap.",
  infil_ev_vault_cat: "Infiltration Case / Corporate State",
  infil_ev_vault_title: "The Secret Vault",
  infil_ev_vault_desc: "A hidden vault holds the crown-jewel documents.",
  infil_ch_vault_a_label: "Skip the vault",
  infil_ch_vault_a_desc: "Leave the vault and grab only your target.",
  infil_ch_vault_b_label: "Crack the e-lock",
  infil_ch_vault_b_desc: "Hack the electronic lock and open it.",
  infil_ch_vault_c_label: "Blow the vault",
  infil_ch_vault_c_desc: "Blast it open and grab everything. Top reward.",
  infil_ev_vaccine_cat: "Infiltration Case / Corporate State",
  infil_ev_vaccine_title: "Vaccination Cover",
  infil_ev_vaccine_desc: "A pop-up clinic is the perfect cover to get inside.",
  infil_ch_vaccine_a_label: "Join the queue",
  infil_ch_vaccine_a_desc: "Line up as an ordinary patient.",
  infil_ch_vaccine_b_label: "Wear a medic gown",
  infil_ch_vaccine_b_desc: "Put on a medic gown and walk inside.",
  infil_ch_vaccine_c_label: "Impersonate the chief",
  infil_ch_vaccine_c_desc: "Pose as the director and dismiss the staff.",
  infil_ev_broadcast_cat: "Infiltration Case / Corporate State",
  infil_ev_broadcast_title: "Broadcast Control Room",
  infil_ev_broadcast_desc: "The station feed could carry your message — or your evidence.",
  infil_ch_broadcast_a_label: "Read the logs",
  infil_ch_broadcast_a_desc: "Quietly review the broadcast logs only.",
  infil_ch_broadcast_b_label: "Intercept the feed",
  infil_ch_broadcast_b_desc: "Hack the feed and siphon the data.",
  infil_ch_broadcast_c_label: "Pose as live director",
  infil_ch_broadcast_c_desc: "Impersonate the live director and take the room.",
  infil_ev_border_cat: "Infiltration Case / Corporate State",
  infil_ev_border_title: "Border Checkpoint",
  infil_ev_border_desc: "A guarded border stands between you and the target.",
  infil_ch_border_a_label: "Take an unwatched trail",
  infil_ch_border_a_desc: "Cross via an unmonitored back trail.",
  infil_ch_border_b_label: "Persuade the officer",
  infil_ch_border_b_desc: "Talk the inspector out of suspicion.",
  infil_ch_border_c_label: "Pose as a diplomat",
  infil_ch_border_c_desc: "Cross under a diplomatic cover identity.",
  infil_ch_border_d_label: "Ram the barrier",
  infil_ch_border_d_desc: "Smash the barrier with a vehicle and floor it.",
} as const;
